import React, { FC } from "react";
import { ISectionCTAsGroup } from "./ISectionCTAsGroup";
import { MovableSectionCTAsGroup as Movable } from "./MovableSectionCTAsGroup/MovableSectionCTAsGroup";
import { SimpleSectionCTAsGroup as Simple } from "./SimpleSectionCTAsGroup/SimpleSectionCTAsGroup";

const SectionCTAsGroup: FC<ISectionCTAsGroup.IProps> = (props) => {
  return props.canDragDrop ? (
    <Movable {...props} /> // being used for adding draggable element in the section group
  ) : (
    <Simple {...props} /> // being used for normal element in the section group
  );
};

export default SectionCTAsGroup;
